import type { PlaneSize } from '@Components/BigBrowse/Model/ModelTypes';
import { Image } from 'react-native';

export function getImageSize(url: string): Promise<PlaneSize> {
  return new Promise<PlaneSize>((resolve, reject) => {
    Image.getSize(
      url,
      (width, height) => {
        resolve({ width, height });
      },
      (error) => {
        reject(error);
      }
    );
  });
}
